import { memo } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

const ShareFeedback = () => {
  return (
    <Box
      width="full"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      padding="s32"
      gap="s24"
    >
      <Text.Header2 color="grey800">
        {i18n.t('settings.permissions.group.feedback.title')}
      </Text.Header2>
      <Text.Normal>{i18n.t('settings.permissions.group.feedback.description')}</Text.Normal>
      <Button.Router to={buildUrl('/canny/sso')} type="primary" blankTarget>
        {i18n.t('settings.permissions.group.feedback.action')}
      </Button.Router>
    </Box>
  )
}

export default memo(ShareFeedback)
